module.exports = __webpack_public_path__ + "static/media/heart-chart.b5fabb13.svg";